import {InitPage} from "../index";
import swal from "sweetalert";

class MfWebPushLogs {
    constructor() {
        $(".error_message").on("click", function(){
            let response_error = $(this).data("err-message1");
            const system_error = $(this).data("err-message2");
            let message = "";
            if(response_error)
            {
                response_error = response_error.replaceAll("***", "\n\n");
                message += "Response Massage(s):\n" + response_error;

            }
            if(response_error && system_error) {
            message += "\n\n";
            }
            if(system_error) {
            message += "System Error(s):\n" + system_error;
            }
            swal({
            title: "Messages",
            text: message,
            icon: "error",
            closeOnClickOutside: false,
            buttons: {
                cancel: {
                    text: "Close",
                    value: null,
                    visible: true,
                    className: "sn-btn sn-btn-sm sn-btn-silver",
                    closeModal: true
                }
            },
            dangerMode: true
            });
        });

        $(".sn-more-sales").on("click", function(){
            const payload = $(this).data("payload");
            let output = "";
            for(let i = 0; i < payload.length; i++) {
                let obj = payload[i];
                output += obj.Sales_Line_No + ", ";
            }
            output = output.substr(0, output.length - 2);
            swal({
            title: "Sales Lines Number",
            text: output,
            closeOnClickOutside: false,
            buttons: {
                cancel: {
                text: "Close",
                value: null,
                visible: true,
                className: "sn-btn sn-btn-sm sn-btn-silver",
                closeModal: true,
                }
            },
            dangerMode: true
            });
        });
    }
}

export function LoadPage() {
    InitPage("web_push_operations index", () => {
        const c = new MfWebPushLogs();
    });
}
